export default {
    error: (state) => (type, field, key=null) => {
        const errors = state.errors;
        if(errors === null) return;
        if(errors.hasOwnProperty(type) && errors[type] !== undefined) {
            if(key !== null) {
                if(errors[type].hasOwnProperty(key) && errors[type][key].hasOwnProperty(field)) {
                    return errors[type][key][field][0];
                }
            }else {
                if(errors[type].hasOwnProperty(field)) {
                    return errors[type][field][0];
                }
            }
        }
        return null;
    }
}